const enMessages = {
  /* 01.Main */
  "main.name": "Name",
  "main.sentiment": "Sentiment",
  "main.urgency": "Urgency",
  "main.language": "Language",
  "main.agent": "Agent",
  "main.property_name": "Property Name",
  "main.booking_number": "Booking Number",
  "main.check_out": "Check Out",
  "main.check_in": "Check In",
  "main.adults": "Adults",
  "main.corporate_code": "Corporate Code",
  "main.group_code": "Group Code",
  "main.promo_code": "Promo Code",
  "main.ai_response": "AI Response",
  "main.template_response": "Template Response",
  "main.converttoticket": "Convert to Ticket",
  "main.switch_property": "Switch Property",
  "main.Group_id": "Group ID",
  "main.integration_id": "Integration ID",
  "main.submit": "Submit",
  "main.cancel": "Cancel",
  "main.select_template": "Select a Template",
  "main.rooms": "Rooms",
  "main.rates": "Rates",

  // footer
  "footer.knowledge": "Knowledge",
  "footer.home": "Home",
  "footer.help": "Help",

  // Ticket
  "ticket.submit_form": " Thank you for submitting the form",
  "ticket.ticket": "Ticket",
  "ticket.details": " Please fill the form describing the ticket details.",
  "ticket.select_category": "Select Category",
  "ticket.category": "Category",
  "ticket.title": "Title",
  "ticket.notes": "Notes",
  "ticket.status": "Status",
  "ticket.assigned_to": "Assigned To",
  "ticket.submit_form": "Submit Form",

  "main.total": "Total",
  "main.pastetooutlook": "Paste to Outlook",
  "main.children": "Children",
  "main.promocode": "Promo/Corporate/Group Code",
  "main.exact_match_only": "Exact Match Only",
  "main.search": "Search",
  "main.no_rate_match": "No rates match your selection. Please modify your search and try again.",
  "main.translate_to": "Translate to",
  "main.regenerate": "Regenerate",
  "main.copy_text": "Copy Text",
  "main.additional_instructions": "Additional Instructions",

  "faq.helpcenter": "Help Center",
  "faq.reply.email.sabre.question": "How do I reply to an email using Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Open the email and launch the Aven Hospitality add-in. You can choose between three options: use a pre-defined template, generate an AI response, or convert the email into a ticket. Select the option that best fits the enquiry, review the response, make any edits if needed, and send directly from Outlook.",

  "faq.rates.availability.question": "How do I add rates, availability, and room details to my response?",
  "faq.rates.availability.answer": "Use the + Rates feature to enter guest details such as dates and number of guests, and Concierge will insert accurate availability and pricing into your reply. You can also use + Rooms to include room descriptions and images, helping guests better understand their options.",

  "faq.different.language.question": "What should I do if the email is in a different language?",
  "faq.different.language.answer": "Aven Hospitality Concierge allows you to translate incoming emails into your preferred language, making them easier to understand. You can then generate or edit a response and translate it back to the guest’s language before sending.",

  "faq.pin.addin.question": "How do I make sure the add-in is always available in Outlook?",
  "faq.pin.addin.answer": "To keep Aven Hospitality Concierge always visible, pin the add-in in Outlook. This ensures it opens automatically with every email, allowing you to quickly generate replies, add rates, or include room details without needing to reopen it each time.",

  "faq.knowledge.hub.question": "What is the Knowledge Hub search option?",
  "faq.knowledge.hub.answer": "The Knowledge Hub search allows you to quickly find property-specific information directly within Outlook. You can search for details such as rooms, amenities, policies, or FAQs, and easily insert accurate information into your email responses.",

  "faq.reply.email.myma.question": "How do I reply to an email using Myma?",
  "faq.reply.email.myma.answer": "Open the email and launch the Myma add-in. You can choose between three options: use a pre-defined template, generate an AI response, or convert the email into a ticket. Select the option that best fits the enquiry, review the response, make any edits if needed, and send directly from Outlook.",

  "faq.room.details.question": "How do I add room details to my response?",
  "faq.room.details.answer": "Use + Rooms to include room descriptions and images, helping guests better understand their options.",

  "faq.myma.different.language.question": "What should I do if the email is in a different language?",
  "faq.myma.different.language.answer": "Myma allows you to translate incoming emails into your preferred language, making them easier to understand. You can then generate or edit a response and translate it back to the guest’s language before sending.",

  "faq.myma.pin.addin.question": "How do I make sure the add-in is always available in Outlook?",
  "faq.myma.pin.addin.answer": "To keep Myma always visible, pin the add-in in Outlook. This ensures it opens automatically with every email, allowing you to quickly generate replies, add rates, or include room details without needing to reopen it each time."

};
export default enMessages;